import i18next from 'i18next';

type Params = {
  locale: string;
  translation: Record<string, string>;
};

export function useI18n(params: Params) {
  i18next.init({
    resources: {
      [params.locale]: {
        translation: params.translation,
      },
    },
  });
  const t = i18next.getFixedT(params.locale);

  return { t };
}
